import React, { createRef, useEffect, useRef, useState } from 'react';



import './index.css';

interface Props {
    id?: string,
    icon?: string | React.ReactNode;
    iconCharacter?: string,
    color?: string,
    onClick?: Function,
    disabled?: boolean,
    tooltip?: string,
    tooltipPosition?: 'left' | 'right' | 'inline-left' | 'inline-right',
    tooltipDelay?: boolean,
    badge?: {
        number: number,
        status: string
    },
    size?: 'small' | 'medium' | 'big',
    ref?: any,
    border?: string,
    clickble?: boolean,
    backgroundClickble?: string,
    notALink?: boolean,
    className?: string
    degrade?: boolean,
}

const LcIconLink: React.FC<Props> = (props) => {    
    const disabled = props.disabled || false;    
    const iconLinkClass = `lc-iconlink${props.disabled ? ' disabled' : ''} ${props.size || ''} ${props.className || ''} ${props.notALink ? 'notALink' : ''}`;
    const [tooltipVisible, setTooltipVisible] = useState(false);
    return (
        <div
            id={props.id}
            className={iconLinkClass}
            onClick={() => !disabled && props.onClick && props.onClick()}
            style={{ border: props.border, color: props.clickble ? '#fff' : props.color, backgroundColor: props.clickble ? props.backgroundClickble ? props.backgroundClickble : '#E2E6F3' : '' }}
        >
            <div className="content"
                onMouseOver={() => { setTooltipVisible(true) }}
                onBlur={() => { setTooltipVisible(false) }}
            >
                {
                    typeof props.icon === 'string'
                        ? <i className={`${props.icon} ${props.degrade ? 'degrade' : ''}` } style={{ color: props.color }}>{props.iconCharacter}</i>
                        : props.icon
                }
                {
                    props.badge && props.badge.number > 0 &&
                    <div className={`badge bg-${props.badge.status}`}>
                        <span>{props.badge.number > 99 ? '+99' : props.badge.number}</span>
                    </div>
                }
            </div>
            {
                (props.tooltip && tooltipVisible) &&
                <div className={`tooltip ${props.tooltipPosition || 'inline-left'} ${props.tooltipDelay ? ' delay' : ''}`}>
                    <div className={`body ${props.tooltipPosition || 'inline-left'}`}>
                        <span className={`arrow ${props.tooltipPosition || 'inline-left'}`} />
                        <div className={`content ${props.tooltipPosition || 'inline-left'}`}>
                            {props.tooltip}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default LcIconLink;